import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { getPartnershipRole } from "@msuite/utils/partnerships";
import type { Tables } from "@msuite/utils/types";
import { useAuth } from "@/hooks/use-auth";

/** Props Interface */
interface PartnerRoleCellProps {
	partnership: Tables<"organizationPartnerships">;
}

/**
 * The counterpart's role from the viewer's side: on a row the viewer hosts, the counterpart is
 * the viewer's subcontractor; on a row the counterpart hosts, it is the viewer's client.
 */
export function PartnerRoleCell({ partnership }: PartnerRoleCellProps) {
	/** Hooks */
	const { t } = useTranslation();
	const { organization } = useAuth();

	/** Computed */
	const role = getPartnershipRole(organization.id, partnership);

	/** Guard */
	if (!role) return null;

	/** Render */
	return (
		<Tag
			color={role === "host" ? "blue" : "purple"}
			variant="plain"
		>
			{role === "host" ? t("partners.role_subcontractor") : t("partners.role_client")}
		</Tag>
	);
}
